<template>
    <el-form class="ruleForm" ref="ruleForm" :model="fromData" :rules="config.rules" :labelWidth='config.labelWidth' >
        <el-row>
        <el-col v-for="item in config.component" :span="item.span" :key="item.prop">
            <el-form-item :label="item.name" :prop="item.prop">
                <component :is="item.component" :type="item.type" v-model="fromData[item.prop]" v-bind="item.useAttr" :style="{width: item.width}"
                @change="changeOrClear($event,item)">
                    <component  v-for="(chi,key) in item.options" :is="item.chiType" :label="chi.label" :value="chi.value" :key="key">
                    </component>
                </component>
            </el-form-item>
        </el-col>
        </el-row>
        <el-row>
            <el-col v-for="item in config.slotComponent" :key="item.prop" :span="item.span">
                <el-form-item :label="item.name" :prop="item.prop" :label-width="item.width" >
                    <slot :name="item.slotName"></slot>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
export default {
    name: 'LogisticsFeSnMFrom',
    props: {
        config: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            fromData: {}
        };
    },

    mounted() {
    },
     watch: {
        fromData: {
            handler(val) {
                this.$emit('onFromDataChange', val);
            },
            deep: true
        }
    },
    methods: {
        // 提交保存
        submit(callback) {
             this.$refs['ruleForm'].validate((valid) => {
               callback(valid, this.fromData);
            });
        },
        // 数据回显
        setFromData(val = {}) {
           if (!Object.keys(val).length) val = { enableFlag: 'Y' };
            this.fromData = val;
        },
        // 重置数据
        reset() {
            this.fromData = {};
        },
        // 清空已校验
        resetFields() {
            this.$refs['ruleForm'].resetFields();
        },
        clearValidate(arr) {
            this.$refs['ruleForm'].clearValidate(arr);
        },
        // 选中或者清空 把关联的数据清空
        changeOrClear(key, item) {
            if ((!key || !key.length) && Array.isArray(item.relevance)) {
                item.relevance.forEach(element => {
                    this.fromData = {
                        ...this.fromData,
                        [element]: Array.isArray(this.fromData[element]) ? [] : ''
                    };
                });
                this.clearValidate(item.relevance);
            } else if (item.relevance) {
                 this.fromData = {
                    ...this.fromData,
                    [item.relevance]: ''
                };
            }
            this.$emit('changeOrClear', key, item);
        }

    }
};
</script>

<style lang="less" scoped>
.ruleForm {
   ::v-deep .el-input.is-disabled .el-input__inner {
        background: #f6f8fa !important;
        border: 1px solid rgba(206, 206, 206, 1) !important;
        border-radius: 2px !important;
    }
}

</style>